<div class="flex flex-col gap-4 p-3 rounded-md border border-proffeo-border">
  <div class="text-sm font-medium text-proffeo-text">
    {{ 'time-report-manual-hours-durations' | translate }}
  </div>

  @for (field of durationFields(); track field.name) {
    <div class="flex flex-col items-center gap-2">
      <span class="text-sm text-proffeo-text">{{ field.labelKey | translate }}</span>
      <proffeo-ui-time-picker
        [maxHour]="99"
        [minuteStep]="minuteStep()"
        [formField]="field.field"
      />
    </div>
  }

  <div class="text-center text-sm font-medium text-proffeo-text">
    {{ 'time-report-manual-hours-total' | translate }}: {{ totalDurationLabel() }}
  </div>
</div>
